import React, { useEffect, useState, useContext } from "react";
import { Context } from "../../context/Context";

const apiUrl = process.env.REACT_APP_BACKEND_URL;

const Profile = () => {
  const { token } = useContext(Context);
  const [user, setUser] = useState({
    _id: "",
    imie: "",
    nazwisko: "",
    email: "",
    telefon: "",
    haslo: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  // Fetch user profile data on component mount
  useEffect(() => {
    if (!token) {
      setError("Please log in to view your profile.");
      return;
    }

    const fetchUserProfile = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${apiUrl}/api/user/profile`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`, // Include the token here
          },
        });

        const data = await response.json();

        if (data.success === false) {
          setError(data.message || "Failed to fetch profile data.");
        } else {
          setUser({
            _id: data._id,
            imie: data.imie,
            nazwisko: data.nazwisko,
            email: data.email,
            telefon: data.telefon,
            haslo: data.haslo,
          });
        }
      } catch (error) {
        console.error("Error fetching profile:", error);
        setError("Failed to fetch profile.");
      } finally {
        setLoading(false);
      }
    };

    fetchUserProfile();
  }, [token]); // Add token as a dependency

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser((prevState) => ({ ...prevState, [name]: value }));
  };

  // Handle profile update
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      setError("Please log in to update your profile.");
      return;
    }

    setLoading(true);

    // Send the user ID and other fields in the request body
    try {
      const response = await fetch(`${apiUrl}/api/user/edit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // Include the token here
        },
        body: JSON.stringify({ ...user }), // Include user data in the request body
      });

      const data = await response.json();
      if (data.success) {
        setSuccess("Profile updated successfully!");
        setError(""); // Clear any previous error messages
      } else {
        setError(data.errors || "Failed to update profile.");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      setError("Failed to update profile.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center  h-full bg-[#f5ebdc] w-full">
      <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-6 sm:p-8">
        <h1 className="text-2xl font-bold text-center mb-6 text-[#313131]">
          Edytuj Profil
        </h1>

        {/* Error and Success messages */}
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        {success && (
          <p className="text-green-500 text-center mb-4">{success}</p>
        )}

        {/* Form */}
        <form
          onSubmit={handleSubmit}
          className="w-full bg-gray-100 p-4 rounded-md mt-2 h-full"
        >
          <div className="flex gap-4 flex-wrap">
            <div className="flex flex-col w-full md:w-1/2">
              <label className="text-[#313131]">Imię</label>
              <input
                type="text"
                name="imie"
                value={user.imie}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="flex flex-col w-full md:w-1/2">
              <label className="text-[#313131]">Nazwisko</label>
              <input
                type="text"
                name="nazwisko"
                value={user.nazwisko}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="flex flex-col w-full md:w-1/2">
              <label className="text-[#313131]">Email</label>
              <input
                type="email"
                name="email"
                value={user.email}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="flex flex-col w-full md:w-1/2">
              <label className="text-[#313131]">Telefon</label>
              <input
                type="text"
                name="telefon"
                value={user.telefon}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
            <div className="flex flex-col w-full md:w-1/2">
              <label className="text-[#313131]">Hasło</label>
              <input
                type="password"
                name="haslo"
                value={user.haslo}
                onChange={handleChange}
                className="p-2 border border-gray-300 rounded-md"
              />
            </div>
          </div>

          {/* Update Profile Button */}
          <button
            type="submit"
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition duration-200"
            disabled={loading}
          >
            {loading ? "Aktualizowanie..." : "Zapisz Zmiany"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;
